import CartItem from '@/classes/CartObject';

class ProductCartItem extends CartItem {
  type = 'PRODUCT';

  name = '';
  poolId = '';

  constructor() {
    super();
    return true;
  }
}

export default ProductCartItem;



// WEBPACK FOOTER //
// ./src/classes/ProductCartItem.js